import React from 'react';
import { currentLang } from '../../../../utils/functions';

const VALID_ANIMAL_TYPES = ['cow', 'chicken', 'pig', 'sheep', 'duck', 'codfish'];

const getAnimalImages = (animalType) => {
  const imageCount = {
    cow: 8,
    chicken: 6,
    pig: 6,
    sheep: 5,
    duck: 6,
    codfish: 6
  };

  const count = imageCount[animalType] || 1;
  const lang = currentLang();
  const baseUrl = lang === 'de'
    ? 'https://www.kaufnekuh.de/storage/farmshop-gallery'
    : 'https://www.grutto.com/storage/farmshop-gallery';
  return Array.from({ length: count }, (_, index) => ({
    src: `${baseUrl}/${animalType}/${String(index + 1).padStart(2, '0')}.jpg`,
    alt: `${animalType} image ${index + 1}`
  }));
};

const getDefaultImages = () => {
  // Generate 6 default images
  const lang = currentLang();
  const baseUrl = lang === 'de'
    ? 'https://www.kaufnekuh.de/storage/farmshop-gallery'
    : 'https://www.grutto.com/storage/farmshop-gallery';
  return Array.from({ length: 6 }, (_, index) => ({
    src: `${baseUrl}/default/${String(index + 1).padStart(2, '0')}.jpg`,
    alt: `Default gallery image ${index + 1}`
  }));
};

const Gallery = ({ animalType, bio = false }) => {
  const normalizedAnimalType = animalType?.toLowerCase();
  const isValidAnimalType = VALID_ANIMAL_TYPES.includes(normalizedAnimalType);
  
  const images = isValidAnimalType 
    ? getAnimalImages(normalizedAnimalType)
    : getDefaultImages();

  return (
    <div className={"recipe-gallery-wrapper" + (bio ? " bio" : "")}>
      <div className={"recipe-gallery d-none"}>
          {images.map((image, index) => (
              <div key={index} className="itm">
                  <img 
                    src={image.src}
                    alt={image.alt}
                    title={image.alt}
                    width={300}
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover'                
                    }}
                  />
              </div>
          ))}
      </div>
    </div>
  );
};

export default Gallery;